import { render, staticRenderFns } from "./cartoes.vue?vue&type=template&id=1236bb3c"
import script from "./cartoes.vue?vue&type=script&lang=js"
export * from "./cartoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports